import React, { useState } from 'react';
import { COLORS } from '@constants';
import { Button, Icon } from '@ui';
import { Flex } from 'antd';
import InviteDeveloperModal from '../../../../../Register/components/InviteDeveloper/components/InviteDeveloperModal';
import { InviteCard, InviteCardContent, InviteCardDescription, InviteCardTitle } from './styled';

const InviteDeveloperCard = () => {
    const [isInviteDeveloperModal, setIsInviteDeveloperModal] = useState(false);

    return (
        <React.Fragment>
            <InviteCard>
                <InviteCardContent data-e2e='onboarding-wizard_invite-developer_content'>
                    <Icon size='80px' color={COLORS.$gray40Black} component={() => <Icon.SpecificProductsIcon />} />
                    <Flex vertical gap={8}>
                        <InviteCardTitle data-e2e='onboarding-wizard_invite-developer_title'>
                            Invite your developer to Klickly
                        </InviteCardTitle>
                        <InviteCardDescription data-e2e='onboarding-wizard_invite-developer_description'>
                            We highly encourage you to bring a developer onto your team to facilitate the technical
                            setup of Klickly. This process will involve configuring APIs, webhooks, and scripts.
                        </InviteCardDescription>
                    </Flex>
                    <Button
                        type='secondary'
                        size='large'
                        onClick={() => setIsInviteDeveloperModal(true)}
                        style={{
                            border: `2px solid ${COLORS.$gray20Black}`,
                            color: COLORS.$gray60Black,
                            backgroundColor: COLORS.$white
                        }}
                        data-e2e='onboarding-wizard_invite-developer_btn'
                    >
                        Invite a developer
                    </Button>
                </InviteCardContent>
            </InviteCard>
            <InviteDeveloperModal
                isModalOpen={isInviteDeveloperModal}
                setIsModalOpen={setIsInviteDeveloperModal}
                customTop={220}
                customLeft={405}
                closeWithoutNavigate
            />
        </React.Fragment>
    );
};

export default InviteDeveloperCard;
